<template>
    <div class="business">
    <toast-message
        :message="errmsg"
        type="error"
        :isToastEnable="toast"
        @close="(val) => toast = val"
    />

    <div>
        <div class="bulkUploadClass" v-if="uploadMethod =true">
            <div class="download-btn">
                <download-button @downloadTemplate="downloadTemplate" >
                </download-button>
            </div>
            <div class="margin-t-15px">
                <upload class="margintop-16" :tobucket="false"  ref="bulkFile" @change="onUploadTemplate($event)" />   
            </div>
        </div>
      
  

      <pop-up-message
        v-if="showSuccessMsg"
        :message="`Bulk_Upload_File.xls Successfully Uploaded.`"
        btnText="OK"
        @back="goToBack"
      ></pop-up-message>

        <pop-up-message
        v-if="showSuccessBulkUploadMsg"
        :message="`${responseMsg} Bulk_Upload_File.xls Successfully Uploaded.`"
        btnText="Back"
        @back="goToBack"
      ></pop-up-message>
      <pop-up-message
      v-if="showErrorPopup"
      message=""
      popupType="Warning"
      :popupHeaderMessage="'UPLOAD FAILED!!!'"
      :message="`${logMessage}`">
      
      
        <template v-slot:bottomContent>
        <div class=" margintop-32">
          <div class="Rectangle margintop-32">
          <span class="Information-message"></span>
        </div>
      </div>
      <div class="margintop-32 custom-container">
      <a :href="logSheetUrl"
        @click="downloadItem(logSheetUrl)"
      ><img src="@/assets/download.svg"  class="img" /> <span class="text">Error Log Sheet</span></a>
          </div>
          <div class="popup-btn-group margintop-32 marginright">
            <button class="btn-popup" type="button" @click="backfromlogpopup()">Back To IT Approval</button>
          </div>
        </template>
    </pop-up-message>
      <footer>
        <popup-bottom-container>
          <template slot="end">
            <btn-grp class="form-button">
              <btn text="Back" type="secondary" @click="closePopup()"/>
              
              <btn  v-if="enableButton==true" text="Save" type="primary" @click ="savePlan()"/>
            </btn-grp>
          </template>
        </popup-bottom-container>
      </footer>
      <div class="not-found-user-modal" v-if="notFoundUser">
        <div class="not-found-user-modal-content">
        <data-table
        :columns="employeeTableColumns"
        :tableData="employeeData"
        :showinrow="true"
        :with-form="false"
        :showhistory="false"
        :showdelete="false"
        :showedit="false">
        </data-table>
        <div class="btn-right-style">
          <btn text="Back" type="primary" @click ="backNotFoundUSer()"/>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions,mapGetters,mapState } from 'vuex';
import { api_variables } from "@/apis/variables.js";
import DataTable from '../../../../../../components/DataTable.vue';
export default {
    name: "incomeTaxBulkPopup",
    props: {
  
        DataTable},
  data() {
    return {
      showSuccessBulkUploadMsg:false,
      errmsg: "",
      toast: false,
      showSuccessMsg: false,
      enableButton: false,
      formData: new FormData(),
      employeeData: [],
      employeeTableColumns: [
        {
          label: "Code",
          key: "code"
        },
        {
          label: "Status",
          key: "status"
        },
      ],
      notFoundUser: false,
      showErrorPopup:false,
      logSheetUrl: null,
      logMessage: null,
      componentKey: 0,
    };
  },
  computed: {
    ...mapState({
      payrollYear: state => state.payroll.runpayroll.payrollYear,
      payrollMonth: state => state.payroll.runpayroll.payrollMonth
    }),
     ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),

    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
    
    uploadParams() {
      let obj = {
        financial_year:this.payrollYear
      };
      return obj;
    }

  },

  mounted() {
    this.showSuccessMsg = false;
  },

  activated() {
    this.toast = false;
    this.errmsg = "";
    this.showSuccessMsg = false;
  },

  methods: {
    ...mapActions({
         act_bulk_upload:"dashboard/payroll/incometax/it_bulk",
         act_approval_download_template: "dashboard/payroll/incometax/getAprrovalTemplate",
         act_tax_approval_upload: "dashboard/payroll/incometax/taxApprovalUploadTemplate",
    }),

    async downloadTemplate() {
     try {
        let obj = {
            le_id : this.le_id,
            financial_year: this.payrollYear,
        }
        let res = await this.act_approval_download_template(obj);
     } catch (error) {
       this.toast = true;
       this.errmsg = error;
     }
   },
      closePopup() {
        this.$emit('hidepopup');
      },
      savePlan() {
        this.showSuccessMsg = true;
        ////console.log("Stop data");
      },

      goToBack() {
        this.showSuccessBulkUploadMsg = false;
      this.showSuccessMsg = false;
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/payroll/incometax`,
      });
      this.$emit('hidepopup');
     // window.location.reload();
    },
    backfromlogpopup(){
      this.showErrorPopup = false;
      this.componentKey += 1;
    },
     /* function to get response after uploading in bulk */
     async onUploadTemplate(event) {

       let monthArray = ["January", "February", "March"]
       let financialYearForApi
       let payrollMonthForApi =  this.payrollMonth.slice(0,3).toLowerCase()
       if (monthArray.includes(this.payrollMonth)) {
         let year = this.payrollYear -1
         financialYearForApi = year 
       } else {
         financialYearForApi = this.payrollYear
       }
      let year = financialYearForApi;
      let month = payrollMonthForApi;
      let formData = new FormData();
      formData.append("file", event);
      formData.append("le_id", this.le_id);
      formData.append(
        "financial_year",
        year
      );
      formData.append("month", month)

      this.$root._data.isSaving = true;
      try {
        let res = await this.act_tax_approval_upload(formData);
        if (res && res.data && res.data.payload && !res.data.payload[0] != '') {
          this.responseMsg = res.data.message ? res.data.message : "";
          this.$refs.bulkFile.uploaded = true;
          this.$refs.bulkFile.uploading = false;
          this.showSuccessBulkUploadMsg = true;
        } else {
          this.logMessage = 'Failed';
          this.showErrorPopup = true;
          this.logSheetUrl = res.data.payload;
        }
        setTimeout(() => {
          this.$root._data.isSaving = false;
        }, 500);
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    },
    backNotFoundUSer() {
      this.notFoundUser = false;
      //this.enableButton = true;
      this.$emit('hidepopup');
    }
  },
}
</script>

<style lang="scss" scoped>
.uploadDiv {
  width: 10%;
  margin-left: auto;
  text-align: center;
  justify-content: end;
  padding: 4px 0px 0px 0px;
  button {
    cursor: pointer;
    width: 60%;
    height: 70%;
    border-radius: 4px;
    color: #5d409f;
    border: 1px solid #5d409f;
  }
  img {
    height: 70%;
    margin-bottom: -6px;
  }
}
.lop-report {
  display: grid;
  grid-template-columns: 0.3fr 0.3fr 0.3fr auto;
  grid-gap: 10px;
}
.export-emp {
  float: right;
  margin-bottom: 1%;
  margin-top: 3%;
}
.export-section {
  margin-left: 12%;
  margin-top: 5px;
  align-items: center;
  display: flex;
}
.export-button {
  width: 85px;
  height: 20px;
  border-radius: 4px;
  font-family: Montserrat;
  font-size: 12px;
  text-align: center;
  border: 1px solid #5d409f;
  color: #5d409f;
  margin-left: 5px;
  margin-right: 10px;
}
.sorttext {
  // width: 10%;
  text-align: center;
  line-height: 30px;
  color: #726f75;
  padding: 0px 0px 0px 10px;
}
.sorticons {
  width: 13%;
  padding: 8px 0px 5px 10px;
  span {
    padding-top: 10px;
    padding-left: 10px;
    border-left: 2px solid #34c0be;
  }
}
.cardClass {
  margin-bottom: 2%;
}
.download-btn {
  margin-top: 2%;
}
.upload {
  display: flex;
  width: 30%;
  margin-top: 2%;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(
      to right,
      lightgray 10px,
      rgba(255, 255, 255, 0) 0%
    ),
    linear-gradient(lightgray 10px, rgba(255, 255, 255, 0) 0%),
    linear-gradient(to right, lightgray 10px, rgba(255, 255, 255, 0) 0%),
    linear-gradient(lightgray 10px, rgba(255, 255, 255, 0) 0%);
  background-position: top, right, bottom, left;
  background-repeat: repeat-x, repeat-y;
  background-size: 20px 1px, 1px 20px;
  height: 140px;
}
.upload-button {
  display: flex;
  align-items: center;
  label {
    cursor: pointer;
    border: 1px solid #5d409f;
    border-radius: 4px;
    padding: 6px 12px;
    font-size: 15px;
    color: #5d409f;
  }
  #upload-photo {
    opacity: 0;
    position: absolute;
    z-index: -1;
  }
  img {
    height: 19px;
    width: 19px;
    margin-right: 8px;
  }
}
.details {
  color: #979797;
  font-size: 11px;
  b {
    color: #535353;
  }
}

.not-found-user-modal {
  display: block;
  position: fixed;
  z-index: 6;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.6);
  -webkit-backdrop-filter: blur(14px);
  backdrop-filter: blur(10px); 
}

.not-found-user-modal-content {
  max-height: 500px;
  overflow-y: scroll;
  background-color: white;
  margin: 150px auto 0px auto;
  z-index: 20;
  width: 50%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  border-radius: 12px;
  //opacity: 0;
  padding: 30px 30px 30px 30px;
  -webkit-animation-name: showPopup-data-v-e576876a;
  -webkit-animation-duration: 0.3s;
  -webkit-animation-delay: 0s;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-fill-mode: forwards;
}

.btn-right-style {
  margin: 12px 0px;
}
</style>